import headshotNoBackground from '../assets/images/headshot-background.png';
import './bio.scss';

export function Bio() {
    return (
        <div class="bio-card">
            <div class="bio-background-wrapper">
                <div class="bio-background" />
            </div>
            <div class="bio-info">
                <p class="bio-info-text">Josh Hussey</p>
                <p class="bio-info-text">Engineer</p>
            </div>
            <img class="bio-headshot" src={headshotNoBackground} alt="headshot" />
        </div>
    )
}

export default Bio;
